import tenantApi from 'src/api/clients/tenant';
import { BookingStatistics } from '../types/response/booking-statistics.response';

export const fetchMonthlyBookingStatistics = async (
  from: string | null,
  to: string | null,
  types?: string[],
  floors?: number[],
): Promise<BookingStatistics> => {
  const { data } = await tenantApi.get<BookingStatistics>(
    `/booking-statistics/monthly`,
    {
      params: {
        from,
        to,
        ...(types?.length ? { types } : {}),
        ...(floors?.length ? { floors } : {}),
      },
    },
  );

  return data;
};

export const fetchDailyBookingStatistics = async (
  from: string | null,
  to: string | null,
  types?: string[],
  floors?: number[],
): Promise<BookingStatistics> => {
  const { data } = await tenantApi.get<BookingStatistics>(
    `/booking-statistics/daily`,
    {
      params: {
        from,
        to,
        ...(types?.length ? { types } : {}),
        ...(floors?.length ? { floors } : {}),
      },
    },
  );

  return data;
};
